import React from "react";
import Alert1 from "../assets/images/Alert1.svg";
import Alert2 from "../assets/images/Alert2.svg";
import Alert3 from "../assets/images/Alert3.svg";
import Alert4 from "../assets/images/Alert4.svg";
import Appstorelogo from "../assets/images/AppstorelogoBlack2.png";
import Appstorelogo1 from "../assets/images/AppstorelogoBlack.png";
import { Link } from "react-router-dom";

const SalesSolutions = () => {
  const data = [
    {
      nameOne: "Easy Mobile",
      nameTwo: "Forms",

      icon: Alert1,
    },
    {
      nameOne: "Instant Alerts &",
      nameTwo: "Notifications",

      icon: Alert2,
    },
    {
      nameOne: "Remote",
      nameTwo: "Closing",

      icon: Alert3,
    },
    {
      nameOne: "Chat with",
      nameTwo: "Verified Buyers",

      icon: Alert4,
    },
    {
      nameOne: "Download",
      nameTwo: "Right Now",
      icon: Appstorelogo,
      Link: "https://apps.apple.com/us/app/realtybase/id1581598890",
      icon2: Appstorelogo1,
    },
  ];
  return (
    <div>
      {" "}
      <section className="salesSolutions container  py-5">
        <div className="row d-flex flex-column flex-md-row justify-content-center gap-3 mt-lg-5 px-4  px-md-0 ">
          {data?.map((data, index) => (
            <div
              style={{
                backgroundColor: data.nameOne === "Download" ? "#FFE500" : "black",
                borderRadius: "30px",
                color: data.nameOne === "Download" ? "black" : "white",
                padding: "40px 0px"
              }}
              className="col-xxl-2 col-xl-3 col-md-5 d-flex flex-column align-items-center text-center justify-content-center "
              key={index}
            >


              <div className=" d-flex flex-column justify-conten-center align-items-center gap-1 " >
                {data.Link ? (
                  <a href={data.Link} target="_blank" rel="noopener noreferrer">
                    <img src={data.icon} alt={`${data.nameOne} ${data.nameTwo}`} />
                  </a>
                ) : (
                  <img src={data.icon} alt={`${data.nameOne} ${data.nameTwo}`} />
                )}
                {data.nameOne === "Download" &&
                  <a
                    href="https://play.google.com/store/apps/details?id=com.laytra.realestate&hl=en"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <img src={data.icon2} alt="image" /></a>}
              </div>

              <div

                className=" mt-2 text-center  px-4 d-flex flex-column align-items-center"
              >


                <h5 className="font-face-PlusJakartaSans-Bold p-0 m-1">{data.nameOne}</h5>
                <h5 className="font-face-PlusJakartaSans-Bold">{data.nameTwo}</h5>
              </div>
            </div>
          ))}

        </div>
      </section>
    </div>
  );
};

export default SalesSolutions;
